export async function getImages(setImages, gender, skinType, abortCont) {

    let uri = process.env.REACT_APP_BASE_URL;

    fetch(`${uri}read_images.php?gender=${encodeURIComponent(gender)}&skin_type=${encodeURIComponent(skinType)}`, { signal: abortCont.signal})
        .then(res => res.json())
        .then(
            (result) => {

              setImages(result)
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              console.log('error:'+ error)
            }
          )
}